import { BilletsYardPage } from "@/pages/billets/BilletsYardPage";
import { RouteConfig } from "./types";
import { BilletsYardStatisticsPage } from "@/pages/billets/statistics";
import { BilletsYardStatusPage } from "@/pages/billets/yard-status";

// Define Billet routes with flat structure
export const billetRoutes: RouteConfig[] = [
  {
    path: "/billets-yard-history",
    element: <BilletsYardPage />,
    permission: "ui.navbar.byi.billets-yard-history",
  },
  {
    path: "/billets-yard-statistics",
    element: <BilletsYardStatisticsPage />,
    permission: "ui.navbar.byi.billets-yard-history",
  },
  {
    path: "/billets-yard-status",
    element: <BilletsYardStatusPage />,
    permission: "ui.navbar.byi.billets-yard-history",
  },
];
